export enum ReportFileFormats {
    CSV = "CSV",
    JSON = "JSON",
    PDF = "PDF",
}

export enum FileStatus {
    PENDING = "pending",
    CREATED = "created",
    UNKNOWN = "unknown",
}
